import { render, staticRenderFns } from "./ProductsListTable.vue?vue&type=template&id=3dd52b4c&"
import script from "./ProductsListTable.vue?vue&type=script&lang=ts&"
export * from "./ProductsListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports